import React, { ReactNode } from 'react';
import { NavMetricPublisher } from 'src/commons/utils/metrics';
import { logger } from 'src/commons/utils/logger';
import { useConsolidatedNavContext } from 'src/providers/ConsolidatedNavContextProvider';
import { getRemoteEntryUrl } from './loadInterstitialRemote';

interface Props {
  entityId?: string;
  children: ReactNode;
}

interface InnerProps {
  onError: () => void;
  entityId?: string;
  children: ReactNode;
}

class InterstitialErrorBoundaryInner extends React.Component<
  InnerProps,
  { hasError: boolean }
> {
  override state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  override componentDidCatch(error: Error) {
    NavMetricPublisher.publishCounterMonitor('interstitial_modal_error', 1);
    const loaderUrl = getRemoteEntryUrl();
    const url = window.location.href;
    logger.error(
      `[InterstitialModal] Error caught, falling back to default navigation (loaderUrl=${loaderUrl}, url=${url}, entityId=${this.props.entityId})`,
      error,
    );
    this.props.onError();
  }

  override render() {
    if (this.state.hasError) {
      return null;
    }
    return this.props.children;
  }
}

export const InterstitialErrorBoundary: React.FC<Props> = ({
  entityId,
  children,
}) => {
  const { setHasInterstitialError } = useConsolidatedNavContext();

  return (
    <InterstitialErrorBoundaryInner
      onError={() => setHasInterstitialError(true)}
      entityId={entityId}
    >
      {children}
    </InterstitialErrorBoundaryInner>
  );
};
